import type { SVGProps } from "react";
import * as React from "react";

const SvgCode = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M15.293 17.293a1 1 0 0 0 1.414 1.414zM22 12l.707.707a1 1 0 0 0 0-1.414zm-5.293-6.707a1 1 0 1 0-1.414 1.414zm-8 1.414a1 1 0 0 0-1.414-1.414zM2 12l-.707-.707a1 1 0 0 0 0 1.414zm5.293 6.707a1 1 0 0 0 1.414-1.414zm9.414 0 6-6-1.414-1.414-6 6zm6-7.414-6-6-1.414 1.414 6 6zm-15.414-6-6 6 1.414 1.414 6-6zm-6 7.414 6 6 1.414-1.414-6-6z"
    />
  </svg>
);
export default SvgCode;
